module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tenancy.owner) ? _c('h4', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.tenancy.owner.name))]) : _vm._e(), _c('br'), _vm._v(" "), (this.isSuper()) ? _c('div', [_c('el-button', {
    attrs: {
      "icon": "fa fa-trash-alt",
      "size": "small",
      "type": "danger",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteTenancy()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "tenancy",
      "label": "Tenancy"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(_vm.tenancy.landTitleRef) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Land Tile Ref:")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.tenancy.landTitleRef))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Tenancy Status")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.renewal) ? _c('div', [_c('b', [_vm._v(_vm._s(_vm.tenancy.landStatus))]), (_vm.renewal.started) ? _c('i', [_vm._v("  " + _vm._s(_vm.tenancy.landType === 'Rental' ? this.addSuffix(this.renewal.term, false) + ' Renewal' : _vm.tenancy.landType + 'd') + ": " + _vm._s(_vm.formatFriendlyDate(_vm.renewal.started)))]) : _vm._e()]) : _c('div', [_c('b', [_vm._v(_vm._s(_vm.tenancy.landStatus))]), (_vm.tenancy.started) ? _c('i', [_vm._v("  " + _vm._s(_vm.tenancy.landType === 'Rental' ? 'Rented' : _vm.tenancy.landType + 'd') + ": " + _vm._s(_vm.formatFriendlyDate(_vm.tenancy.started)))]) : _vm._e()])])], 1), _vm._v(" "), (_vm.tenancy.classificationType) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Classification Type:")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.tenancy.classificationType))])])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Tenancy Type")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.renewal) ? _c('div', [(_vm.tenancy.landType) ? _c('b', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.tenancy.landType) + " " + _vm._s(_vm.formatMoney(_vm.renewal.amount) + ' ' + (_vm.tenancy.frequency ? _vm.tenancy.frequency : '')))]) : _vm._e()]) : _c('div', [(_vm.tenancy.landType) ? _c('b', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.tenancy.landType) + " " + _vm._s(_vm.formatMoney(_vm.tenancy.landValue) + ' ' + (_vm.tenancy.frequency ? _vm.tenancy.frequency : '')))]) : _vm._e()])])], 1), _vm._v(" "), (_vm.tenancy.deposit) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Deposit")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.formatMoney(_vm.tenancy.deposit)))]), _vm._v(" "), (_vm.tenancy.depositMonths) ? _c('span', [_c('i', [_vm._v(" (for " + _vm._s(_vm.plural('month', _vm.tenancy.depositMonths, true))), (_vm.tenancy.depositDate) ? _c('span', [_vm._v(" on " + _vm._s(_vm.formatDate(_vm.tenancy.depositDate)))]) : _vm._e(), _vm._v(")")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "align": "right"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24,
      "align": "right"
    }
  }, [(_vm.canAccess('property|finance')) ? _c('div', [_c('tenancy-action', {
    attrs: {
      "site-data": _vm.site,
      "tenancy-data": _vm.tenancy,
      "contact-data": _vm.contact,
      "read-only": _vm.readOnly
    },
    on: {
      "update": _vm.savedTenancy
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.showRenewalButton && !_vm.isPurchase(_vm.tenancy) && _vm.canAccess('property')) ? _c('el-col', {
    attrs: {
      "align": "right",
      "span": 24
    }
  }, [((_vm.tenancy.renewal || !_vm.renewed) && !_vm.isPurchase(_vm.tenancy)) ? _c('renewal-action', {
    attrs: {
      "tenancy-data": _vm.tenancy,
      "site-data": _vm.site,
      "disabled": !_vm.isManager() || _vm.readOnly
    },
    on: {
      "change": _vm.renewalChanged
    }
  }) : _vm._e(), _vm._v(" "), _c('br')], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.owner.name) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Owner")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.owner.name))])])], 1) : _vm._e(), _vm._v(" "), (_vm.owner.address) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Address")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.owner.address))])])], 1) : _vm._e(), _vm._v(" "), (_vm.owner.postCode) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Post Code")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.owner.postCode))])])], 1) : _vm._e(), _vm._v(" "), (_vm.owner.phone) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Phone")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.owner.phone))])])], 1) : _vm._e(), _vm._v(" "), (_vm.owner.email) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("e-Mail")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.owner.email + '?subject=RE: Tower Site ' + _vm.site.siteName + ' (' + _vm.site.siteId + ')'
    }
  }, [_vm._v(_vm._s(_vm.owner.email))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.owner && _vm.owner.beneficiaryName1 && _vm.canAccess('finance')) ? _c('el-row', {
    attrs: {
      "gutter": 11
    }
  }, [_c('br'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Bank")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.owner.beneficiaryName1) ? _c('i', [_vm._v(_vm._s(_vm.owner.beneficiaryName1) + " \n                ")]) : _vm._e(), _c('strong', [_vm._v(_vm._s(_vm.owner.bankName1))]), _vm._v("\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.owner.bankAccount1),
      expression: "owner.bankAccount1"
    }]
  }, [_vm._v("a/c: "), _c('strong', [_vm._v(_vm._s(_vm.owner.bankAccount1))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20,
      "offset": 4
    }
  }, [(_vm.owner.beneficiaryName2) ? _c('i', [_vm._v(_vm._s(_vm.owner.beneficiaryName2) + " \n                ")]) : _vm._e(), _c('strong', [_vm._v(_vm._s(_vm.owner.bankName2))]), _vm._v("\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.owner.bankAccount2),
      expression: "owner.bankAccount2"
    }]
  }, [_vm._v("a/c: "), _c('strong', [_vm._v(_vm._s(_vm.owner.bankAccount2))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20,
      "offset": 4
    }
  }, [(_vm.owner.beneficiaryName3) ? _c('i', [_vm._v(_vm._s(_vm.owner.beneficiaryName3) + " \n                ")]) : _vm._e(), _c('strong', [_vm._v(_vm._s(_vm.owner.bankName3))]), _vm._v("\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.owner.bankAccount3),
      expression: "owner.bankAccount3"
    }]
  }, [_vm._v("a/c: "), _c('strong', [_vm._v(_vm._s(_vm.owner.bankAccount3))])])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.owner && _vm.contact && _vm.contact.name) ? _c('el-row', [_c('br'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Owner's Rep.")])]), _vm._v(" "), (_vm.contact) ? _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.contact.name) ? _c('span', [_vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.contact.name))]), _vm._v(" "), (_vm.contact.phone) ? _c('span', [_vm._v("\n                   "), _c('i', {
    staticClass: "fa fa-phone"
  }, [_vm._v(" ")]), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.contact.phone
    }
  }, [_vm._v(_vm._s(_vm.contact.phone))])]) : _vm._e(), _vm._v(" "), (_vm.contact.email) ? _c('span', [_vm._v("\n                     "), _c('i', {
    staticClass: "fa fa-envelope"
  }, [_vm._v(" ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.contact.email + '?subject=RE: Tower Site ' + _vm.site.siteName + ' (' + _vm.site.siteId + ')'
    }
  }, [_vm._v(_vm._s(_vm.contact.email))])]) : _vm._e()]) : _vm._e()]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isPurchase(_vm.tenancy) && _vm.owner && _vm.showAgreement && (_vm.canAccess('property|finance') || _vm.isLandlordCo())) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('br'), _vm._v(" "), _c('data-table', {
    attrs: {
      "table-ref": "renewalTable",
      "title": _vm.tenancy.landType + ' Renewals',
      "url": '/tenancy/renewals/' + _vm.tenancy.id,
      "show-search": false,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return [(_vm.isManager('property|finance')) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "circle": "",
            "icon": "fa fa-trash",
            "size": "mini",
            "disabled": _vm.readOnly
          },
          on: {
            "click": function($event) {
              return _vm.deleteRenewal(props.rowData)
            }
          }
        }) : _vm._e()]
      }
    }], null, false, 1936448372)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('files-panel', {
    attrs: {
      "title": "Tenancy Attachments",
      "type": "site",
      "id": _vm.tenancy.site_id,
      "process": "tenancy",
      "process-id": _vm.tenancy.id,
      "max-files": 5,
      "disabled": !_vm.isManager('property|management')
    }
  }), _vm._v(" "), (_vm.tenancy.remarks) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h6', [_vm._v("Remarks")]), _vm._v(" "), _c('div', {
    staticClass: "html-remarks"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.tenancy.remarks)
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.tenancy.updated_at) ? _c('div', [_c('hr'), _vm._v(" "), (_vm.isManager('property') && !_vm.hideDelete) ? _c('span', [_c('el-button', {
    attrs: {
      "type": "danger",
      "circle": "",
      "size": "small"
    },
    on: {
      "click": _vm.deleteTenancy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("Last update: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.tenancy.updated_at)))]), (_vm.tenancy.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.tenancy.updated_by))]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), (_vm.owner && (_vm.canAccess('finance|property') || _vm.isLandlordCo())) ? _c('el-tab-pane', {
    attrs: {
      "name": "statement",
      "label": "Statement"
    }
  }, [_c('site-finance-tenancy', {
    attrs: {
      "row-data": _vm.rowData,
      "read-only": _vm.readOnly
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tenancy.utilAccount || _vm.tenancy.utilAddress || _vm.tenancy.utilDeposit || _vm.tenancy.utilDepositDate) ? _c('el-tab-pane', {
    attrs: {
      "name": "utility",
      "label": this.utilLabel + ' Details'
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.utilLabel) + " Details")]), _vm._v(" "), (_vm.tenancy.util && _vm.tenancy.util.name) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Utilities Provider")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.tenancy.util.name))]), _vm._v(" [" + _vm._s(_vm.tenancy.util.shortName) + "]\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.tenancy.utilAccount) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.utilLabel) + " Acc. #")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.tenancy.utilAccount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.tenancy.utilAddress) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Address")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.tenancy.utilAddress))])])], 1) : _vm._e(), _vm._v(" "), (_vm.tenancy.utilDeposit) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Deposit")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatMoney(_vm.tenancy.utilDeposit)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.tenancy.utilDepositDate) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gr
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Desposit Date")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.tenancy.utilDepositDate)))])])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b43362"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/property/Tenancy.vue
// module id = 1563
// module chunks = 0